import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { GeneralErrorService } from '../services/general-error.service';
import { GeneralErrorTypes } from '../models/general-error-types';

export const DEFAULT_TIMEOUT = 70000;

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  generalErrorService = inject(GeneralErrorService);
  private readonly ignoreErrorApiList = ['digipay/api/files/', '/events/send-event'];
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = req.headers.get('timeout') || DEFAULT_TIMEOUT;
    const timeoutValueNumeric = Number(timeoutValue);
    return next.handle(req).pipe(
      timeout(timeoutValueNumeric),
      catchError((err) => {
        if (this.isTimeOUtError(err)) {
          this.generalErrorService.error.set(GeneralErrorTypes.INTERNET_ERROR);
        }
        return throwError(() => err);
      }),
    );
  }

  isTimeOUtError(err: any): boolean {
    if (err && err.url && this.ignoreErrorApiList.some((str) => err.url.includes(str))) {
      return false;
    }
    return err.status === 0 || err.name === 'TimeoutError';
  }
}
